/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.link-external\":\"Square with an upward arrow to the right\"}");